const childrenLoaded = require('@alexspirgel/children-loaded');
import $ from 'jquery';

class ComponentAnchorLinks extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);

		const resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				if (entry.target) {
					const offset = entry.target.getBoundingClientRect().height;
					this.updateAnchorPointsMargin(offset);					
				}
			}
		});
		resizeObserver.observe(this);

		for (const linkElement of this.linkElements) {
			linkElement.addEventListener('click', this.linkClickHandler);
			$(window).on('scroll', function () {
				var sectionTop = $($(linkElement).attr('href')).offset().top;
				if($(this).scrollTop() >= sectionTop - 200){
					$('.component-anchor-links__link').removeClass('active');
					$(linkElement).addClass('active');
				}
			});
		}
		for (const menuContainerElement of this.menuContainerElements) {
			menuContainerElement.addEventListener('click', (e) => {
				this.toggleMenu(e, e.target);
			});
		}
	}

	get linkElements() {
		return this.querySelectorAll('.component-anchor-links__link');
	}

	get menuContainerElements() {
		return this.querySelectorAll('.component-anchor-links__inner');
	}

	linkClickHandler = (event) => {
		event.preventDefault();
		const linkElement = event.target;
		if (linkElement) {
			const anchorId = linkElement.getAttribute('href');
			if (anchorId) {
				history.pushState({}, '', anchorId);
				let vw = window.innerWidth || 0;
				if (vw <= 768) {
					this.toggleMenu(event, document.querySelector('.component-anchor-links__heading-btn'));
				}
				const anchorElement = document.querySelector(anchorId);
				if (anchorElement) {
					// Timeout to avoid animations interfering with scroll calculation.
					const timeout = vw <= 768 ? 400 : 0;
					window.setTimeout(() => {
						anchorElement.scrollIntoView({inline: 'start', behavior:'smooth'});
					}, timeout);
				}
			}
		}
		return false;
	}

	toggleMenu = (event, element) => {
		event.preventDefault();
		if (!($(element).hasClass('component-anchor-links__item') || $(element).hasClass('component-anchor-links__link'))) {
			const menuContainer = $(event.target).hasClass('component-anchor-links__inner') ? element : $(element).closest('.component-anchor-links__inner');
			const $menuEl = $(menuContainer).find('.component-anchor-links__items');
			const $headingBtnEl = $(menuContainer).find('.component-anchor-links__heading-btn');
			if ($menuEl.data('open') == false) {
				$menuEl.data('open', true);
				$menuEl.css('display', 'flex').hide().fadeIn(150);
			}
			else {
				$menuEl.data('open', false);
				$menuEl.fadeOut(150);
			}
			$headingBtnEl.animate({ opacity: 0 }, 120);
			$headingBtnEl.animate({ opacity: 1 }, 120);
			setTimeout(function () {
				const expandedStatus = $headingBtnEl.attr('aria-expanded') === 'true' ? true : false;
				$headingBtnEl.attr('aria-expanded', (!expandedStatus).toString());
				$headingBtnEl.delay(150).toggleClass('active');
			}, 120);
		}
	}

	updateAnchorPointsMargin = (margin) => {
		const anchorPoints = document.querySelectorAll('.component-anchor-point, .program__section-anchor');
		let vw = window.innerWidth || 0;
		const loggedInOffset = $('body').hasClass('gin--horizontal-toolbar') ? vw <= 976 ? 39 : 53 : 0;
		let yOffset = vw <= 768 ? 89 : margin;
		yOffset += loggedInOffset;
		[...anchorPoints].forEach(anchorPoint => {
			anchorPoint.style.marginTop = -yOffset + 'px';
		});
	}	

}
customElements.define('component-anchor-links', ComponentAnchorLinks, {extends: 'div'});